import { render, staticRenderFns } from "./CampaignGroupTab.vue?vue&type=template&id=44fbec3a&scoped=true&"
import script from "./CampaignGroupTab.vue?vue&type=script&lang=ts&"
export * from "./CampaignGroupTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fbec3a",
  null
  
)

export default component.exports